import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const POST_CREATE_POST = 'POST_CREATE_POST'
export const createPostApi = apiCall(
  POST_CREATE_POST,
  ({ siteId, ...payload }: { siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/posts`),
    method: 'POST',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_UPDATE_POST = 'POST_UPDATE_POST'
export const updatePostApi = apiCall(
  POST_UPDATE_POST,
  ({
    id,
    siteId,
    ...payload
  }: { id: string; siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/posts/${id}`),
    method: 'PATCH',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_UPDATE_POST_SETTINGS = 'POST_UPDATE_POST_SETTINGS'
export const updatePostSettingsApi = apiCall(
  POST_UPDATE_POST_SETTINGS,
  ({
    id,
    siteId,
    ...payload
  }: { id: string; siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/posts/${id}/settings`),
    method: 'PATCH',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_UPDATE_POST_METADATA = 'POST_UPDATE_POST_METADATA'
export const updatePostMetadataApi = apiCall(
  POST_UPDATE_POST_METADATA,
  ({
    id,
    siteId,
    ...payload
  }: { id: string; siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/posts/${id}/metadata`),
    method: 'PATCH',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_DELETE_POST = 'POST_DELETE_POST'
export const deletePostApi = apiCall(
  POST_DELETE_POST,
  ({ id, siteId }: { id: string; siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/posts/${id}`),
    method: 'DELETE',
    headers: appApiHeaders(),
  }),
)
